import { useTranslation } from 'react-i18next';

import { TextareaField } from 'fields';

import type { INotes } from './types';

export default function Notes({ disabled }: INotes) {
  const { t } = useTranslation('CreateOrder');

  return (
    <TextareaField
      disabled={disabled}
      name="packagedItemNotes"
      label={t('ProductForm.labels.notes')}
      placeholder={t('ProductForm.placeholders.notes')}
    />
  );
}
